module.exports = __webpack_public_path__ + "img/foto_voortuin.2bbfd841.jpg";